import {IReportComparativeNomenclatureData, IReportComparativeStoresData, IReportDynamicsData, IReportTotalData} from "../../models/reports/performance.interface";

export interface IReportTotalState {
  data: Array<IReportTotalData>;
  isDataLoaded: boolean;
}
export interface IReportComparativeStoresState {
  data: Array<IReportComparativeStoresData>;
  isDataLoaded: boolean;
}
export interface IReportComparativeNomenclatureState {
  data: Array<IReportComparativeNomenclatureData>;
  isDataLoaded: boolean;
}
export interface IReportDynamicsState {
  data: Array<IReportDynamicsData>;
  isDataLoaded: boolean;
}
//---------------
export const initialReportTotalState:IReportTotalState = {
  data: [],
  isDataLoaded: false
};
export const initialReportComparativeStoresState:IReportComparativeStoresState = {
  data: [],
  isDataLoaded: false
};
export const initialReportComparativeNomenclatureState:IReportComparativeNomenclatureState = {
  data: [],
  isDataLoaded: false
};
export const initialReportDynamicsState:IReportDynamicsState = {
  data: [],
  isDataLoaded: false
};
